<template>
  <v-app>
    <Nav :isAuthenticated="isAuthenticated" :currentUser="currentUser" @contact="openContactModal" @logout="doLogout"/>
    <v-content :class="appBg" v-cloak>
      <router-view />
    </v-content>
    <v-footer fixed color="transparent" v-if="isAuthenticated && $can('create_aid')">
      <v-spacer></v-spacer>
      <div class="floating-button">
        <v-btn fab dark color="accent" title="New Data Entry" to="/aids/create">
          <v-icon dark>add</v-icon>
        </v-btn>
      </div>
    </v-footer>
    <keep-alive>
      <ContactModal :isOpen="contactModalOpen" @closed="contactModalOpen = false" />
    </keep-alive>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

import Nav from '@/components/Nav/Nav.vue'
import ContactModal from '@/components/Contact/ContactModal.vue'

export default {
  name: 'App',
  components: {
    Nav,
    ContactModal
  },
  data () {
    return {
      navSideOpen: false,
      contactModalOpen: false
    }
  },
  created () {
    this.$http.interceptors.response.use((response) => {
      if (response.data.code === 401) {
        return this.doLogout()
      }
      return response
    })
  },
  computed: {
    appBg () {
      const authRoutes = ['auth.login', 'auth.admin', 'auth.reset', 'auth.register']
      if (this.$route.name === 'home') return 'app-bg-white'
      else if (authRoutes.includes(this.$route.name)) return 'app-bg-img'
      return 'no-app-bg'
    },
    ...mapGetters(['isAuthenticated', 'currentUser'])
  },
  methods: {
    doLogout () {
      this.$router.push({ name: 'auth.logout' })
    },
    openContactModal () {
      this.contactModalOpen = true
    }
  }
}
</script>

<style>
[v-cloak] {
  display: none;
}
.app-bg-img {
  background: url(./assets/images/bg.png);
}
.app-bg-white {
  background: #fff
}
.floating-button {
  position: relative;
  right: 20px;
  bottom: 30px
}
</style>
